import { useAppSelector } from "../../app/hooks";
import { selectHotel } from "../../features/hotel/hotelSlice";
import type { IHotelRoomOccupancyAvailabilityPrice } from "../../features/hotel/hotelInterface";
import { formatCurrency } from "../../helpers/currency";

interface IFormatPricing {
  pricing?: {
    Price?: IHotelRoomOccupancyAvailabilityPrice;
    MaxPrice?: IHotelRoomOccupancyAvailabilityPrice;
    ReferencePrice?: IHotelRoomOccupancyAvailabilityPrice;
  } | null;
  discountPrice?: boolean;
  maxPrice?: boolean;
  referencePrice?: boolean;
  quantity?: number;
}

const averagePerNight = (
  price: IHotelRoomOccupancyAvailabilityPrice | undefined,
  currencyCode: string,
) => price?.AveragePerNight?.[currencyCode] ?? 0;

export default function FormatPricing({
  pricing,
  discountPrice = false,
  maxPrice = false,
  referencePrice = false,
  quantity = 1,
}: IFormatPricing) {
  const hotel = useAppSelector(selectHotel);
  const currencyCode = hotel.Culture.CurrencyCode ?? "EUR";

  let calculatedPrice = 0;

  if (referencePrice && pricing?.ReferencePrice) {
    calculatedPrice = averagePerNight(pricing.ReferencePrice, currencyCode);
  } else if (maxPrice) {
    calculatedPrice = averagePerNight(pricing?.MaxPrice, currencyCode);
  } else if (discountPrice) {
    const reference =
      pricing?.ReferencePrice?.AveragePerNight?.[currencyCode] ??
      pricing?.MaxPrice?.AveragePerNight?.[currencyCode] ??
      0;
    calculatedPrice = reference - averagePerNight(pricing?.Price, currencyCode);
  } else {
    calculatedPrice = averagePerNight(pricing?.Price, currencyCode);
  }

  return <span>{formatCurrency(calculatedPrice * quantity)}</span>;
}
